<script setup>

</script>

<template>
  <div class="wrapper">
    <div class="container">
      <h1>绑定成功</h1>
      <p>您的微信账号绑定成功！</p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  width: 100vw;
  height: 100vh;
  font-family: Arial, sans-serif;
  text-align: center;
  margin: 0;
  padding: 10px;
  background-color: #fff;
}
.container {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
  height: 165px;
}
h1 {
  color: #4CAF50;
  font-size: 32px;
  margin: 21px 0;
}
</style>